import { injectGlobal } from 'styled-components'

import colors from './colors'

// TODO - transitions
// http://reactcommunity.org/react-modal/styles/transitions.html
injectGlobal`
  .ReactModalPortal {
    z-index: 10000;
    position: absolute;
  }

  .ReactModal__Overlay {
    background: ${colors.smoke} !important;
  }

  .ReactModal__Content {
    left: 50% !important;
    bottom: auto !important;
    right: auto !important;
    width: 360px;
    max-width: 100%;
    border: none !important;
    padding: 1rem !important;
    box-shadow: 0 1rem 2rem ${colors.smoke};
    transform: translateX(-50%);
  }
  .ReactModal__Content h2 {
    margin: 0 0 1rem;
  }

  .DayPicker {
    margin: 0 -1rem;
  }
  /* .DayPicker,
  .CalendarMonthGrid,
  .CalendarMonth {
    padding: 0 !important;
    left: 0 !important;
    right: 0 !important;
  }
  .DayPickerNavigation_button:first-child {
    left: 0 !important;
    right: auto !important;
  }
  .DayPickerNavigation_button:last-child {
    left: auto !important;
    right: 0 !important;
  } */
`


// WEBPACK FOOTER //
// ./src/styles/modals.js